import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import './ResetPasswordPage.css';

function ResetPasswordPage() {
  const [params] = useSearchParams();
  const email = params.get("email");
  const token = params.get("token");

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');

  const handleReset = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setMessage("Las contraseñas no coinciden.");
      return;
    }

    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/users/reset-password`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, token, password }),
    });

    if (res.ok) {
      setMessage("Contraseña cambiada exitosamente.");
    } else {
      setMessage("Error al cambiar la contraseña.");
    }
  };

  return (
    <div className="reset-password-container">
      <h2>Cambiar Contraseña</h2>
      <form onSubmit={handleReset} className="reset-password-form">
        <input
          type="password"
          placeholder="Nueva contraseña"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Confirmar contraseña"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />
        <button type="submit">Guardar</button>
      </form>
      {message && <p className="reset-password-message">{message}</p>}
    </div>
  );
}

export default ResetPasswordPage;
